import React, {ReactNode} from "react";
import {ChildrenPropsTypes} from "./childrenProps.types.ts";

export default function childrenFilter(children: ReactNode, type: ({children}: ChildrenPropsTypes) => ReactNode) {
    if (typeof children === "undefined") {
        return;
    }

    return React.Children.toArray(children).find(
        (child) => (React.isValidElement(child) && child.type === type)
    );
}